
import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-16 bg-brand-lightPink">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            <span className="text-brand-pink">قصتنا</span>
          </h2>
          
          <p className="text-lg leading-relaxed mb-6">
            في عروسة عدن، نحن نحافظ على تقاليد العطور اليمنية الغنية التي تم تناقلها عبر الأجيال. تبدأ قصتنا من الحب العميق للروائح الطبيعية والفريدة التي تميز ثقافتنا.
          </p>
          
          <p className="text-lg leading-relaxed mb-6">
            نفخر بتقديم عطور يدوية الصنع باستخدام أجود المكونات الطبيعية، مستلهمة من التراث اليمني العريق. كل زجاجة عطر تحكي قصة وتحمل جزءًا من تراثنا.
          </p>
          
          <p className="text-lg leading-relaxed">
            عطورنا مثالية للمناسبات الخاصة، خاصة حفلات الزفاف والأعياد، حيث تضيف لمسة من الفخامة والتميز. ندعوك لاستكشاف عالمنا العطري وتجربة سحر الروائح الشرقية الأصيلة.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
